import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import TypeSelector from "./views/TypeSelector"
import Confirmation from "./views/Confirmation"
import ShowInvoice from "./views/ShowInvoice"

Vue.use(Router);

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/room-select',
      name: 'TypeSelector',
      component: TypeSelector
    },
    {
      path: '/booking-confirmation',
      name: 'Confirmation',
      component: Confirmation
    },
    {
      path: '/show-invoice/:id',
      name: 'ShowInvoice',
      component: ShowInvoice,
      props: true
    },
  ]
})